module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "centerImage1"
  }, [_c('a', {
    attrs: {
      "id": "map1"
    }
  }), _c('img', {
    attrs: {
      "alt": "images",
      "src": "images/map-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Plan of the battles of Tel-el-Kebir and Kassassin, 1882")]), _vm._v(". "), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("(From Sir Evelyn Wood, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("British Battles on Land and Sea")]), _vm._v(", London: Cassell & Co., 1915)")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-abf81504","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/10_chapter011.vue
// module id = 87
// module chunks = 0